import { createWebHistory, createRouter } from 'vue-router'
import useAuth from '../store/auth.store'
import Main from '../views/main/Index.vue'
import Auth from '../views/auth/Index.vue'
import Notfound from '../views/notfound/Index.vue'
import VForbidden from '../views/forbidden/Index.vue'

import BoardDeviceEvents from '../views/main/board/device-event/Index.vue'
import BoardAddress from '../views/main/board/address/Index.vue'
import BoardDevice from '../views/main/board/device/Index.vue'
import BoardCustomer from '../views/main/board/customer/Index.vue'
import BoardMonitor from '../views/main/board/monitor/Index.vue'
import BoardRoles from '../views/main/board/roles/Index.vue'
import BoardLogs from '../views/main/board/logs/Index.vue'
import BoardUsers from '../views/main/board/users/Index.vue'
import BoardSettings from '../views/main/board/settings/Index.vue'
import Map from '../views/main/board/map/Index.vue'

import AuthLogin from '../components/auth/AuthLogin.vue'

const auth = useAuth()

const routes = [
  {
    path: '/',
    name: 'main',
    component: Main,
    meta: { restricted: true },
    redirect: { name: 'board-monitor' },
    children: [
      {
        path: '/map',
        name: 'map',
        meta: { menu: 'ADDRESSES' },
        component: Map,
      },
      {
        path: '/forbidden',
        name: 'forbidden',
        component: VForbidden,
      },
      {
        path: '/device-events',
        name: 'board-purchase',
        meta: { menu: 'DEVICE_EVENTS' },
        component: BoardDeviceEvents
      },
      {
        path: '/device',
        name: 'board-device',
        meta: { menu: 'DEVICES' },
        component: BoardDevice
      },
      {
        path: '/address',
        name: 'board-address',
        meta: { menu: 'ADDRESSES' },
        component: BoardAddress
      },
      {
        path: '/customer',
        name: 'board-customer',
        meta: { menu: 'CUSTOMERS' },
        component: BoardCustomer
      },
      {
        path: '/roles',
        name: 'board-roles',
        meta: { menu: 'ROLES' },
        component: BoardRoles
      },
      {
        path: '/logs',
        name: 'board-logs',
        meta: { menu: 'LOGS' },
        component: BoardLogs
      },
      {
        path: '/monitor',
        name: 'board-monitor',
        meta: { menu: 'DASHBOARD' },
        component: BoardMonitor
      },
      {
        path: 'users',
        name: 'board-users',
        meta: { menu: 'USERS' },
        component: BoardUsers
      },
      {
        path: 'settings',
        name: 'board-settings',
        meta: { menu: 'SETTINGS' },
        component: BoardSettings
      },
    ]
  },
  {
    path: '/auth',
    name: 'auth',
    component: Auth,
    redirect: { name: 'auth-login' },
    children: [
      {
        path: '/auth/login',
        name: 'auth-login',
        meta: {
          label: 'Login',
        },
        component: AuthLogin
      }
    ]
  },
  {
    path: '/notfound',
    name: 'notfound',
    component: Notfound
  },
  {
    path: '/:catchAll(.*)',
    redirect: { name: 'notfound' }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

router.beforeEach((to) => {
  const isAuthenticated = auth.isAuthenticated.value
  const allowedMenus = auth.allowedMenus.value
  const toLogin = to.matched.find(item => item.name === 'auth-login')

  if (isAuthenticated && toLogin) return { name: 'main' }
  if (!isAuthenticated && !toLogin) return { name: 'auth-login' }

  console.log(allowedMenus);
  const isAllowed = to.matched.every(v => !v.meta.menu || allowedMenus.includes(v.meta.menu))

  if (!isAllowed) return { name: 'forbidden', query: { path: to.path } }
})

export default router